import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import { sendMenssageRequest, sendMenssageSuccess, sendMenssageFailure } from './actions';

export function* sendMenssageReq({ payload }: ReturnType<typeof sendMenssageRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}novaMensagem&token=${state.auth.token}`,
      {
        protocolo: payload.protocolo,
        texto: payload.texto,
        anexos: payload.anexos,
      }
    );
    yield put(sendMenssageSuccess(response.data));
  } catch (error: any) {
    yield put(sendMenssageFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao enviar mensagem, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
